import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

// components
import SubHeader from '../../components/SubHeader';
import Select from '../../components/Select';
import Pagination from '../../components/Pagination';
import ReceiptsTable from './components/ReceiptsTable';
import LocationModal from './components/LocationModal';
import Search from '../../components/Search';
import Button from '../../components/Button';

// redux
import { getReceipts, getReceiptsBigNumbers, updateSelectedPeriod } from './receipts-store';

// css
import './styles.css';

class Receipts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filterOptions: [
        { value: 1, label: 'Último mês' },
        { value: 3, label: 'Últimos 3 meses' },
        { value: 6, label: 'Últimos 6 meses' },
        { value: 12, label: 'Últimos 12 meses' },
        { value: 'ALL', label: 'Todos os registros' },
      ],
      currentPage: 1,
      pageLimit: 10,
      paginationOptions: [
        { value: 10, label: '10' },
        { value: 25, label: '25' },
        { value: 50, label: '50' },
        { value: 100, label: '100' },
      ],
      searchTerm: null,
      locationModalIsVisible: false,
      activeLocation: null,
      activeAddress: null,
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getReceipts(1, this.state.pageLimit));
    dispatch(getReceiptsBigNumbers());
  }

  _onBigNumbersRetry = () => {
    const { dispatch } = this.props;

    dispatch(getReceiptsBigNumbers());
  }

  _onGetReceiptsRetry = () => {
    const { dispatch } = this.props;

    dispatch(getReceipts(1, this.state.pageLimit));
  }

  _updateFilterValue = ({ value }) => {
    const { dispatch } = this.props;

    dispatch(updateSelectedPeriod(value));
    dispatch(getReceipts(1, this.state.pageLimit, this.state.searchTerm));
    dispatch(getReceiptsBigNumbers(this.state.searchTerm));
  }

  // Table
  _onPageChange = (currentPage) => {
    const { dispatch } = this.props;

    this.setState({ currentPage });
    dispatch(getReceipts(currentPage, this.state.pageLimit, this.state.searchTerm));
  }

  _onAmountChange = (pageLimit) => {
    const { dispatch } = this.props;

    this.setState({
      currentPage: 1,
      pageLimit,
    });

    dispatch(getReceipts(1, pageLimit, this.state.searchTerm));
  }

  _onSearch = (searchTerm) => {
    const { dispatch } = this.props;
    const { pageLimit } = this.state;

    this.setState({
      currentPage: 1,
      searchTerm,
    });

    dispatch(getReceipts(1, pageLimit, searchTerm));
    dispatch(getReceiptsBigNumbers(searchTerm));
  }

  _toggleLocationModal = (activeLocation, activeAddress) => {
    this.setState({
      locationModalIsVisible: !this.state.locationModalIsVisible,
      activeLocation,
      activeAddress,
    });
  }

  _onOrderChange = (newOrder) => {
    const { dispatch } = this.props;
    const { pageLimit } = this.state;

    dispatch(getReceipts(1, pageLimit, null, newOrder));
  }

  render() {
    const {
      getReceiptsUi,
      receipts,
      bigNumbers,
      bigNumbersUi,
      selectedPeriod,
      currentOrder,
    } = this.props;

    const {
      locationModalIsVisible,
    } = this.state;

    return (
      <div className="Receipts__container">
        <SubHeader
          title="Comprovantes"
          renderSide={() => (
            <Search
              placeholder="Busca por número do conhecimento"
              onSearch={this._onSearch}
              className="Receipts__search"
            />
          )}
        />

        <div className="Receipts__big-numbers">
          {
            bigNumbersUi.error &&
            <div className="Receipts__error">
              {bigNumbersUi.error}
              <Button
                onClick={this._onBigNumbersRetry}
                skin="primary"
                text="Tentar Novamente"
                size="small"
                className="Receipts__error-button"
              />
            </div>
          }
          {
            !bigNumbersUi.error &&
            <Fragment>
              <div className="ReceiptsBigNumber">
                <h2 className="ReceiptsBigNumber__title">
                  {bigNumbersUi.isFetching && 'Carregando...'}
                  {!bigNumbersUi.isFetching && bigNumbers.deliveredInvoices}
                </h2>
                <small className="ReceiptsBigNumber__desc">Conhecimentos entregues</small>
              </div>
              <div className="ReceiptsBigNumber">
                <h2 className="ReceiptsBigNumber__title">
                  {bigNumbersUi.isFetching && 'Carregando...'}
                  {!bigNumbersUi.isFetching && bigNumbers.totalNfs}
                </h2>
                <small className="ReceiptsBigNumber__desc">Notas Fiscais</small>
              </div>
              <div className="ReceiptsBigNumber">
                <h2 className="ReceiptsBigNumber__title">
                  {bigNumbersUi.isFetching && 'Carregando...'}
                  {!bigNumbersUi.isFetching && bigNumbers.registeredCte}
                </h2>
                <small className="ReceiptsBigNumber__desc">Canhotos CTE registrados</small>
              </div>
              <div className="ReceiptsBigNumber">
                <h2 className="ReceiptsBigNumber__title">
                  {bigNumbersUi.isFetching && 'Carregando...'}
                  {!bigNumbersUi.isFetching && bigNumbers.unregisteredCte}
                </h2>
                <small className="ReceiptsBigNumber__desc">Canhotos CTE não registrados</small>
              </div>
            </Fragment>
          }
          <div className="Receipts__big-numbers-filter">
            <Select
              options={this.state.filterOptions}
              value={selectedPeriod}
              onChange={this._updateFilterValue}
              closeOnSelect
            />
          </div>
        </div>

        <ReceiptsTable
          isFetching={getReceiptsUi.isFetching}
          error={getReceiptsUi.error}
          receipts={receipts}
          onLocationClick={this._toggleLocationModal}
          onOrderChange={this._onOrderChange}
          currentOrder={currentOrder}
          onRetry={this._onGetReceiptsRetry}
        />

        {/* ====================== */}
        {/* ===== PAGINATION ===== */}
        {/* ====================== */}
        {
          receipts.length > 0 &&
          <Pagination
            options={this.state.paginationOptions}
            currentPage={this.state.currentPage}
            pageLimit={this.state.pageLimit}
            totalItems={receipts.length * 2000}
            onPageLimitChange={this._onAmountChange}
            onChangePage={this._onPageChange}
          />
        }

        {/* ===================== */}
        {/* ===== LOC MODAL ===== */}
        {/* ===================== */}
        {
          locationModalIsVisible &&
          <LocationModal
            location={this.state.activeLocation}
            address={this.state.activeAddress}
            onDismiss={() => { this._toggleLocationModal(null, null); }}
          />
        }

      </div>
    );
  }
}

Receipts.propTypes = {};
Receipts.defaultProps = {};

function mapStateToProps(state) {
  return {
    receipts: state.receipts.receipts.data,
    currentOrder: state.receipts.receipts.order,
    getReceiptsUi: {
      isFetching: state.receipts.receipts.isFetching,
      error: state.receipts.receipts.error,
    },
    bigNumbers: state.receipts.bigNumbers.data,
    bigNumbersUi: {
      isFetching: state.receipts.bigNumbers.isFetching,
      error: state.receipts.bigNumbers.error,
    },
    selectedPeriod: state.receipts.selectedPeriod,
  };
}

export default connect(mapStateToProps)(Receipts);
